

























































































import { Component, Prop, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { Location } from "vue-router";
import { ROUTE_NAMES } from "../../router/routenames";
import DoKoHtmlDialog from "./DoKoHtmlDialog.vue";
import DoKoBtn from "../controls/DoKoBtn.vue";

import { api as userApi } from "../../store/modules/user";
import { SignupUserPayload } from "../../store/modules/user/types";
import { CurrentUser } from "../../store/modules/friends/types";
import { FriendRef } from "@dokogd/shared";

@Component({ components: { DoKoHtmlDialog, DoKoBtn } })
export default class DoKoLogin extends Vue {
  avatarNo = 1;

  username = "";
  email = "";
  password = "";
  passwordConfirm = "";
  loading = false;
  error = "";
  loginRoute: Location = {
    name: ROUTE_NAMES.LOGIN,
  };
  get valid() {
    return true; /*
    return (
      this.username.trim() !== "" &&
      this.email.trim() !== "" &&
      this.password.trim().length > 8 &&
      this.password === this.passwordConfirm
    ); */
  }

  get prevAvatarId() {
    return (this.avatarNo - 1).toString().padStart(3, "0");
  }
  get avatarId() {
    return this.avatarNo.toString().padStart(3, "0");
  }

  get nextAvatarId() {
    return (this.avatarNo + 1).toString().padStart(3, "0");
  }

  @Action(userApi.actions.updateProfile, { namespace: userApi.namespace })
  updateProfile!: (payload: Partial<SignupUserPayload>) => Promise<any>;

  @Getter(userApi.getters.getCurrentUser, { namespace: userApi.namespace })
  currentUser!: CurrentUser | null;

  async changeData() {
    this.loading = true;
    try {
      const password: string | undefined =
        this.password === this.passwordConfirm &&
        this.password.trim().length > 8
          ? this.password
          : undefined;
      const displayName: string | undefined =
        this.currentDisplayName !== this.username.trim()
          ? this.username.trim()
          : undefined;
      const email: string | undefined =
        this.currentEmail !== this.email.trim() ? this.email.trim() : undefined;
      const avatarId: string | undefined =
        this.currentAvatarId !== this.avatarId.trim()
          ? this.avatarId.trim()
          : undefined;

      await this.updateProfile({
        password,
        email,
        avatarId,
        username: displayName,
      });
      this.$router.push({
        name: ROUTE_NAMES.LOBBY,
      });
    } catch (err) {
      console.error(err);
      this.error = err;
    }
    this.loading = false;
  }
  nextAvatar() {
    if (this.avatarNo < 100) {
      this.avatarNo += 1;
    }
  }

  prevAvatar() {
    if (this.avatarNo > 1) {
      this.avatarNo -= 1;
    }
  }

  get currentEmail() {
    return this.currentUser?.email ?? "";
  }
  get currentDisplayName() {
    return this.currentUser?.displayName ?? "";
  }

  get currentAvatarId() {
    return this.currentUser?.avatarId ?? "000";
  }

  mounted() {
    this.avatarNo = parseInt(this.currentAvatarId, 10);
    this.username = this.currentDisplayName;
    this.email = this.currentEmail;
  }
}
